import { InjectionMoldingProductBillOfMaterialsLineItemType } from '../enums/injection-molding-product-bill-of-materials-line-item-type.enum';
import { InjectionMoldingProductBillOfMaterialsLineItem } from '../models/injection-molding-product-bill-of-materials-line-item.model';

export function isValidInjectionMoldingProductBomQuantity(
    lineItem: InjectionMoldingProductBillOfMaterialsLineItem,
): boolean {
    if (lineItem.quantity == null) {
        return lineItem.type === InjectionMoldingProductBillOfMaterialsLineItemType.Material;
    }

    return Number.isFinite(lineItem.quantity) && lineItem.quantity > 0;
}

export function canAdjustInjectionMoldingProductBomInventory(
    lineItems: InjectionMoldingProductBillOfMaterialsLineItem[],
): boolean {
    return lineItems.every((lineItem) => (
        lineItem.quantity != null
        && Number.isFinite(lineItem.quantity)
        && lineItem.quantity > 0
    ));
}
